import { render } from "./Add-aboutdata.vue?vue&type=template&id=aa677a74"
import script from "./Add-aboutdata.vue?vue&type=script&lang=js"
export * from "./Add-aboutdata.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__